<template>
<div class="row" >
      <div v-for="contenido in contenidos" :key="contenido.ContenidoDeMicrositioId" :class="columnasContenido(contenido.TamanoDeLaColumna)">
    <a v-if="contenido.AbrirEnVisor==false" v-on:click="AbrirArchivo(contenido.RutaArchivoCarpeta,'_self')" >  <img src="contenido.RutaDeImagen" >
  </a>
  <a v-if="contenido.AbrirEnVisor==true" v-on:click="AbreElVisor(contenido.RutaArchivoCarpeta)" >  <img :src="contenido.RutaDeImagen" alt="Imagen No Disponible">
  </a>

      </div>
</div>  
</template>

<script>
import comun from "@/../static/js/comun";
export default {
    props:{
        contenidos:Array
    },
    methods:{
       
        columnasContenido(columnas){
            var respuesta = 'col-'+columnas
            return respuesta;
        },
        AbreElVisor: function(vinculo) {
      
       this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo);
      },
         AbrirArchivo: function(vinculo,forma) {
             comun.DescargarDocumentoPDF(vinculo)
           // window.open(vinculo,forma);
        },
    }

}
</script>


// WEBPACK FOOTER //
// src/components/Micrositios/Formatos/Imagen.vue